<template>
  <div class='listDetail'>
    <div class='detail-header'>
      <div v-if='whichList==0'>
        <p>交易成功</p>
      </div>
      <div v-else-if='whichList==1'>
        <p>等待付款</p>
        <p>请尽快付款，超过24小时后将取消订单</p>
      </div>
      <div v-else-if='whichList==2'>
        <p>货品准备中</p>
      </div>
      <div v-else-if='whichList==3'>
        <p>已发货</p>
        <p>还剩9天15时自动确认收货</p>
      </div>
    </div>
    <div class='peo-add'>
      <div class='clearfix'>
        <div class='clearfix'>
          <p>{{listDetail[0].personName}}</p>
          <p>{{listDetail[0].personPhone}}</p>
        </div>
        <p>{{listDetail[0].personAddress}}</p>
      </div>
    </div>
    <div class='pro-list'>
      <div class='pro-name'>商品信息</div>
      <div class='pro-show'>
        <van-card :title="listDetail[0].name"
                  :desc="listDetail[0].color+'-'+listDetail[0].size"
                  :num="listDetail[0].count"
                  :price="listDetail[0].price"
                  :thumb="listDetail[0].goodsDetail.src"
                  :ref="listDetail[0].id"
                  :key="listDetail[0].id">
          <div slot="footer">
            <div style="width:100%;height:100%;z-index:99999"
                 @click="toDetailPage(listDetail[0].id)"></div>
          </div>
        </van-card>
      </div>
    </div>
    <div class='pro-pay clearfix'>
      <div class="postPay clearfix">
        <p>运费</p>
        <p>￥0.00</p>
      </div>
      <div class='needpay clearfix'>
        <p>实付款</p>
        <p class='bg_main'>{{listDetail[0].payMoney}}</p>
      </div>
    </div>
    <div class='pro-main-msg'>
      <div>订单信息</div>
      <ul>
        <li>
          <div><span>订单编号：</span><span>{{listDetail[0].orderNo}}</span></div>
        </li>
        <li>
          <div><span>提交时间：</span><span>{{listDetail[0].sumbitTime}}</span></div>
        </li>
        <li>
          <div><span>支付方式：</span><span>{{listDetail[0].payway}}</span></div>
        </li>
        <li>
          <div><span>实付金额：</span><span>{{listDetail[0].payMoney}}</span></div>
        </li>
        <li>
          <div><span>付款时间:</span><span>{{listDetail[0].payTime}}</span></div>
        </li>
        <li>
          <div><span>发票信息：</span><span>电子纸质发票</span></div>
        </li>
        <li>
          <div><span>发票抬头：</span><span>WIndir</span></div>
        </li>
        <li>
          <div><span>发票内容：</span><span>日用品</span></div>
        </li>
        <li>
          <div><span>发票状态：</span><span>已开发票</span></div>
        </li>
      </ul>
    </div>
    <div class='pro-phone clearfix'>
      <p>对此订单有疑问，请联系在线客服或直接拨打电话咨询</p>
      <div>
        <div @click="contactP(1)">
          联系客服
        </div>
        <div @click="contactP(2)">拨打电话</div>
      </div>
    </div>
    <!-- <div class='pay-last clearfix'>
      <div>
        <span>应付金额：</span>
        <span class='bg_main'
              style='font-size:0.3rem;'>￥459.98</span>
      </div>
      <div>
        <button>取消订单</button>
        <button>立即付款</button>
      </div>
    </div> -->
  </div>
</template>

<script>
import { Dialog } from 'vant';
import { constants } from 'fs';
import { Card } from 'vant';
export default {
  name: "listDetail",
  data () {
    return {
      kid: '',
      whichList: 0,//订单总类、已支付0、待支付1、待发货2、待收货3、待评论4
      listDetail: {},  //当前商品的所有信息，从state中获取
      personName: '',
      personPhone: '',
      isWaitGoods: 0
    }
  },
  created () {

  },
  mounted () {
    ////debugger
    //获取url的param
    var targetGood;
    this.kid = this.$route.params.kid;
    console.log('this.kid:' + this.kid);
    this.whichList = Number(this.$route.params.whichList);
    this.isWaitGoods = Number(this.$route.params.isWaitGoods);

    switch (this.whichList) {
      case 0: targetGood = this.$store.state.allGood; break;//已支付
      case 1: targetGood = this.$store.state.toBepay; break;//待支付
      case 2: targetGood = this.$store.state.allGood; break; //待发货
      case 3: targetGood = this.$store.state.tosendgood; break;//待收货
      case 4: targetGood = this.$store.state.toAssess; break;//待评价
    }
    //问题在这里
    if (targetGood.length != 0) {
      //过滤问题
      this.listDetail = targetGood.filter(listItem => {
        console.log(listItem);
        return listItem.kid == this.kid;
      })
    }
    //当前产品所有信息
    console.log('sads723213');
    console.log(this.listDetail);
    window['backToOrder'] = () => {
      this.$router.push('/orderList');
    }
  },
  computed () {

  },
  methods: {
    contactP (num) {
      if (num == 1) {
        Dialog.alert({
          title: "联系客服",
          message: '请拨打123456'
        })
      } else {
        Dialog.alert({
          title: "拨打电话",
          message: '请拨打123456'
        })
      }
    },
    toDetailPage (itemId) {
      this.$router.push({ name: 'detail', params: { id: itemId } });
    }
  }
}
</script>

<style lang="less">
.van-dialog__message {
  text-align: center;
}
.listDetail {
  width: 100%;
  height: auto;

  .van-card__footer {
    width: 100%;
    height: 100%;
    & > div {
      height: 100%;
    }
  }
  .bg_main {
    color: rgb(255, 144, 0) !important;
  }
  .detail-header {
    height: 1.8rem;
    box-sizing: border-box;
    padding: 0.6rem 0.32rem;
    background-color: rgb(255, 144, 0);

    & > div {
      // background: url("../../../static/image/我的订单/ios/radio1@2x.png")
      //   no-repeat center left;
      color: #fff;
      padding-left: 0.86rem;
      & > p:nth-child(1) {
        font-size: 0.32rem;
        font-weight: bold;
        margin-bottom: 0.16rem;
      }
      & > p:nth-child(2) {
        font-size: 0.22rem;
      }
    }
  }
  .peo-add {
    height: 0.88rem;
    padding: 0.24rem 0.32rem;
    box-sizing: border-box;
    margin-bottom: 0.14rem;

    & > div {
      font-size: 0.24rem;
      color: rgb(102, 102, 102);
      background: url("../../../static/image/myOrder/ios/position.png")
        no-repeat center left;
      padding-left: 0.56rem;
      & > div {
        margin-bottom: 0.12rem;
        & > p:nth-child(1) {
          float: left;
        }
        & > p:nth-child(2) {
          float: right;
        }
      }
    }
  }
  .pro-list {
    width: 100%;
    .pro-name {
      height: 0.78rem;
      background: #fff;
      font-size: 0.26rem;
      line-height: 0.78rem;
      padding-left: 0.24rem;
    }
    .pro-show {
      .van-card {
        background-color: rgb(244, 244, 244);
        padding: 0.24rem;
      }
    }
  }
}
.pro-pay {
  padding: 0 0.24rem;
  font-size: 0.24rem;
  color: rgb(51, 51, 51);
  .postPay,
  .needpay {
    font-size: 0.24rem;
    color: rgb(51, 51, 51);
    height: 0.88rem;
    line-height: 0.88rem;
    border-bottom: 1px solid #e5e5e5;
    & > p {
      &:nth-child(1) {
        float: left;
      }
      &:nth-child(2) {
        float: right;
      }
    }
  }
}

.pro-main-msg {
  padding: 0 0.24rem;

  div {
    height: 0.88rem;
    line-height: 0.88rem;
    font-size: 0.26rem;
    color: rgb(51, 51, 51);
  }
  ul {
    li {
      height: 0.8rem;
      line-height: 0.8rem;
      font-size: 0.24rem;
      color: rgb(102, 102, 102);
    }
  }
}
.pro-phone {
  padding: 0 0.24rem;

  p {
    line-height: 0.8rem;
    height: 0.8rem;
    font-size: 0.24rem;
    color: rgb(102, 102, 102);
  }
  div {
    width: 100%;
    div {
      width: 50%;
      text-align: center;
      float: left;
      color: #333333;
      font-size: 0.26rem;
      height: 0.8rem;
      line-height: 0.8rem;
    }
  }
}
.pay-last {
  height: 0.88rem;
  padding: 0 0.24rem;

  div {
    float: left;
    width: 50%;
    color: rgb(51, 51, 51);
    font-size: 0.24rem;

    button {
      background: #fff;
      border: 1px solid #e5e5e5;
      border-radius: 0.1rem;
      font-size: 0.24rem;
      height: 0.5rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/my/listDetail.vue